// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterAddress_root__aVTGY","title":"FooterAddress_title__ZdZSu","subTitle":"FooterAddress_subTitle__sIMU1","country":"FooterAddress_country__RUtdy"};